import ifma from "../../../assets/REMA/partners/IFMA logo only.png";
import uwana from "../../../assets/REMA/partners/Uwana Energy Logo.png";
import nomba from "../../../assets/REMA/partners/Nomba Logo for Signage.png";
import trebnet from "../../../assets/REMA/partners/trebnet media logo.png";
import sterling from "../../../assets/REMA/partners/Sterling logo blk (1).png";
import cemex from "../../../assets/REMA/partners/logo_cemex.png";
import damcom from "../../../assets/REMA/partners/image 20.png";
import rescueTap from "../../../assets/REMA/partners/RESCUETAP LOGO 1.png";
import rana from "../../../assets/REMA/partners/rana.png";
import shyftpower from "../../../assets/REMA/partners/Shyftpower.png";
import datasek from "../../../assets/REMA/partners/dataseklogo.png";
import principal from "../../../assets/REMA/partners/principal.png";
import electra from "../../../assets/REMA/partners/electra.png";
import provast from "../../../assets/REMA/partners/provast.png";
import halogen from "../../../assets/REMA/partners/halogen.png";
import mtn from "../../../assets/REMA/partners/mtn.png";

export const partners = [
    {
        category: "Platinum Sponsors",
        companies: [
            {
                id: 3,
                logo: nomba,
                webUrl: "https://nomba.com/",
            },
            {
                id: 5,
                logo: mtn,
                webUrl: "https://www.mtn.ng/",
            },
            {
                id: 5,
                logo: sterling,
                webUrl: "https://www.sterling.ng/",
            },
        ],
    },
    {
        category: "Gold Sponsors",
        companies: [
            {
                id: 3,
                logo: provast,
                webUrl: "https://provastltd.com/",
            },
        ],
    },
    {
        category: "Exhibitors",
        companies: [
            {
                id: 2,
                logo: uwana,
                webUrl: "https://uwanaconnect.com/",
            },
            {
                id: 6,
                logo: cemex,
                webUrl: "https://www.cpil.com.ng/",
            },
            {
                id: 9,
                logo: rana,
                webUrl: "https://ranaenergy.io/",
            },
            {
                id: 10,
                logo: shyftpower,
                webUrl: "https://shyftpower.com/",
            },
            {
                id: 11,
                logo: datasek,
                webUrl: "https://datasek.com/",
            },
            {
                id: 8,
                logo: rescueTap,
                webUrl: "https://www.rescuetap.com/",
            },
            {
                id: 8,
                logo: electra,
                webUrl: "https://electra.ng/",
            },
            {
                id: 1,
                logo: principal,
                webUrl: "https://principalfml.com/",
            },
        ],
    },
    {
        category: "Supporting partners",
        companies: [
            {
                id: 1,
                logo: ifma,
                webUrl: "https://www.ifma.org/",
            },


            {
                id: 4,
                logo: trebnet,
                webUrl: "https://www.trebnetdirectory.com/",
            },

            {
                id: 7,
                logo: damcom,
                webUrl: "https://damcom.com.ng/",
            },
            {
                id: 7,
                logo: halogen,
                webUrl: "https://halogen-group.com/",
            },
        ],
    },
];
